import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'Status Page',
  slug: 'status-page',
  definition: `A status page is a public-facing web page that displays the current health and availability of your services. It shows which systems are operational, degraded, or experiencing outages, and provides a history of recent incidents.

Status pages serve two audiences. External status pages are for customers — they can check the page before contacting support to see if a known issue is being worked on. Internal status pages help teams across the organization stay informed during incidents.

A good status page includes current component status, active incident details with updates, historical uptime data, and a subscription option so users get notified of changes.`,
  whyItMatters: `Status pages build trust through transparency. When something goes wrong, users want to know three things: Is there a problem? Are you aware of it? When will it be fixed? A status page answers all three without requiring a support ticket.

For support teams, status pages dramatically reduce ticket volume during outages. Instead of answering hundreds of "is it just me?" messages, support can point users to the status page.`,
  howUptrackHelps: `Uptrack includes built-in status pages that update automatically based on your monitor health. When a confirmed outage is detected, the status page reflects it immediately — no manual intervention required.

You can customize your status page with your own branding and choose which monitors to display. Users can subscribe to updates via email, so they are notified the moment an incident starts or resolves.`,
  relatedTerms: [
    { name: 'Incident Management', href: '/glossary/incident-management' },
    { name: 'Uptime', href: '/glossary/uptime' },
    { name: 'SLA', href: '/glossary/sla' },
    { name: 'Downtime', href: '/glossary/downtime' },
  ],
}

export const Route = createFileRoute('/_site/glossary/status-page')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
